export default function ({ store, route, from }) {
  let comingFromTraining = from.path.indexOf("/training_results") > -1
  let goingToTraining = route.path.indexOf("/training_results") > -1
  let shouldNotReset = (comingFromTraining && goingToTraining)

  if (!shouldNotReset) {
    store.commit("selects/resetStateWithDefaultApi")
  }
}